import React from 'react'

import type { CallToActionStripBlock as CTABlockProps } from '@/payload-types'

import RichText from '@/components/RichText'
import { CMSLink } from '@/components/Link'

export const CallToActionStripBlock: React.FC<CTABlockProps> = ({ links, richText }) => {
  return (
    <div className={'overflow-hidden py-[50px]'}>
      <div className={'-rotate-1 scale-105 shadow-xl'}>
        <div
          className={'h-[40px] w-full -mb-[1px]'}
          style={{
            backgroundImage: `url(/media/film-strip-top-black.png)`,
            backgroundSize: 'contain',
            backgroundRepeat: 'repeat-x',
          }}
        ></div>
        <div className="bg-black flex flex-col justify-center text-white text-center">
          <div className={'container'}>
            <div className={'my-16 flex justify-center text-white'}>
              <div className="flex">
                {richText && (
                  <RichText
                    className="mb-0"
                    content={richText}
                    enableProse={false}
                    enableGutter={false}
                  />
                )}
              </div>
              <div className="flex flex-col gap-8 mt-4">
                {(links || []).map(({ link }, i) => {
                  return <CMSLink key={i} size="lg" {...link} />
                })}
              </div>
            </div>
          </div>
        </div>
        <div
          className={'h-[40px] w-full -mt-[1px]'}
          style={{
            backgroundImage: `url(/media/film-strip-bottom-black.png)`,
            backgroundSize: 'contain',
            backgroundRepeat: 'repeat-x',
          }}
        ></div>
      </div>
    </div>
  )
}
